<template>
  <div class="container bg-white p-x-3:mo">
    <div>
      <div class=" d-flex fd-column:mo ai-center ai-start:mo jc-between:t fd-row:t m-b-2  ">
        <div class="TITLE">Pro Education</div>
        <span @click="whatClick" class="link d-flex m-t-2:t">
          <vk-icon
              name="exclamation-circle-outlined"
              size="18"
              class="m-r-1"
              unbounded/>
          What is this?
        </span>

      </div>
      <hr class="GREY-LINE m-b-2 d-none:t"/>
      <div class="d-flex jc-end p-t-4:t p-b-2">
        <form novalidate @submit.prevent="search($event)" class="p-b-2:t">
          <education-search-input
              class="SEARCH"
              ref="whatsNewSearch"
              @input="search($event)"
              :value="query"
              placeholderText="Search videos"
              @clear="clear"
              @click.native="focused = true">
          </education-search-input>
        </form>
      </div>
      <hr class="GREY-LINE d-none:t"/>
    </div>
    <div class="d-flex fd-column:mo">
      <div class="LEFT-NAV p-b-2:mo">
        <hr class="GREY-LINE  d-none:t"/>
        <education-nav-list
            :sectionTitle="$options.SECTION_TITLES.CATEGORIES"
            :categories="getExtractedItemsByCategory"
            @selection="selection"
            class="m-b-3:t" />
        <hr class="GREY-LINE  d-none:t"/>
        <education-nav-list
            :sectionTitle="$options.SECTION_TITLES.MY_PROGRESS"
            :categories="progress"
            @selection="selection"
            displayAll />
      </div>

      <div class="BODY">
        <div v-for="(value, key) in videos" :key="key">
          <video-collection :ids="value" :title="key" />
          <hr class="GREY-LINE m-b-2 d-none:t"/>
        </div>

      </div>

    </div>
    <vk-modal v-if ="showModal" @close="closeModal">
      <div class="bg-white w-100:mo">
        <vk-modal-header class="HEADER">
          <div class="d-flex">
            <vk-icon
                name="exclamation-circle-outlined"
                size="18"
                class="m-r-1 c-black"
                unbounded/>
            <span class="c-gray90 text-bold">What is this?</span>
          </div>
        </vk-modal-header>
        <vk-modal-content class="d-flex ">
          <div class="VIDEO-FRAME">
            <iframe class="VIDEO" src="https://youtube.com/embed/K8y7yw_911g" allowfullscreen></iframe>
          </div>
        </vk-modal-content>
        <vk-modal-footer>
          <div class="d-flex jc-end">
            <button class="btn-sm btn-secondary m-r-2" @click="closeModal">Close</button>
          </div>
        </vk-modal-footer>
      </div>
    </vk-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EducationSearchInput from './components/EducationSearchInput';
import VideoCollection from './components/VideoCollection';
import EducationNavList from './components/EducationNavList';

const SECTION_TITLES = {
  CATEGORIES: 'Categories',
  MY_PROGRESS: 'My Progress',
};

export default {
  name: 'education',
  components: {
    EducationSearchInput,
    VideoCollection,
    EducationNavList,
  },
  SECTION_TITLES,
  data () {
    return {
      query: this.searchTerm || '',
      showModal: false,
    };
  },
  computed: {
    ...mapGetters('account/pro/education', [
      'getExtractedItemsByGroup',
      'getExtractedItemsByCategory',
      'videoList',
      'sortedRecords',
    ]),
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),
    videos () {
      const { query } = this.$route;
      switch (true) {
        case Object.prototype.hasOwnProperty.call(query, 'category'):
          return { [query.category]: this.getExtractedItemsByCategory[query.category] };
        case Object.prototype.hasOwnProperty.call(query, 'progress'):
          return { [query.progress]: this.progress[query.progress] };
        case Object.prototype.hasOwnProperty.call(query, 'search'):
          return { [query.search]: this.searchedVideos(query.search) };
        default:
          return this.getExtractedItemsByGroup;
      }
    },
    progress () {
      return this.sortedRecords;
    },
  },
  watch: {
    serviceProviderId: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.fetchVideos({ serviceProviderId: newVal });
        }
      },
    },
  },
  mounted () {
    this.$store.dispatch('account/pro/fetch');
  },
  methods: {
    ...mapActions('account/pro/education', ['fetchVideos']),
    search (searchTerm) {
      this.$events.$emit(this.$events.VIDEO_SEARCH, { search_term: searchTerm });
      this.$router.push({
        name: 'dashboard::pro::education',
        query: {
          search: searchTerm,
        },
      });
    },
    clear () {
      this.query = '';
    },
    searchedVideos (term) {
      const matchingVideos = Object.keys(this.videoList).filter((videoId) => {
        const { videoTitle, videoDescription } = this.videoList[videoId];
        return (
          videoTitle.toLowerCase().includes(term.toLowerCase())
          || videoDescription.toLowerCase().includes(term.toLowerCase())
        );
      });
      return matchingVideos;
    },
    whatClick () {
      this.showModal = true;
      this.$events.$emit(this.$events.WHAT_IS_THIS_CLICK);
    },
    selection (category, sectionTitle) {
      if (sectionTitle === SECTION_TITLES.CATEGORIES) {
        this.$events.$emit(this.$events.VIDEO_CATEGORY_CLICK, { name: category });
      } else {
        this.$events.$emit(this.$events.VIDEO_MY_PROGRESS_CLICK, { name: category });
      }
    },
    closeModal () {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
 .TITLE {
    @include margin(4 0 2 0);
    @include h3();
    font-weight: 600;
    @include mobile-only {
      @include margin(4 0 1 0);
    }
  }
  .SEARCH {
    width: $unit * 40;

    @include mobile-only {
      min-width: 100%;
    }
  }
  .GREY-LINE {
    width: 100vw;
    height: 10px;
    margin: 0px 0px 0px -3 * $unit;
    background-color: $color-gray30;
    border: none;

  }
  .LEFT-NAV {
    margin-top: $unit * 3;
    min-width: 28 * $unit;
    @include mobile-only {
      display: flex;
      flex-direction: column-reverse;
      min-width: 100%;
    }
  }
  .BODY {
    width: 100%;
    min-height: 1000px;
  }
  .VIDEO-FRAME {
    @include responsive(width, 100%, 800px);

    position: relative;
    padding-bottom: 56.25%;
  }
  .VIDEO {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;;
  }
  .HEADER {
    color: $color-depot;
    border: 0;
  }
  </style>
